/**
 * This component is modified from Material-UI's core version so we can remove the core MUI lib as a dependancy
 * The original component is found here: https://github.com/mui-org/material-ui/tree/next/packages/material-ui/src/SvgIcon
 */
import * as React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
function capitalize(string) {
    if (typeof string !== 'string') {
        throw new Error('StyleUtililityError: capitalize(string) expects a string argument.');
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const useStyles = makeStyles(({ palette, spacing }) => ({
    /* Styles applied to the root element. */
    root: {
        userSelect: 'none',
        width: spacing(4),
        height: spacing(4),
        display: 'inline-block',
        fill: 'currentColor',
        flexShrink: 0,
        fontSize: '24px',
    },
    xs: {
        height: spacing(1.5),
        width: spacing(1.5),
    },
    small: {
        height: spacing(2),
        width: spacing(2),
    },
    medium: {
        height: 20,
        width: 20,
    },
    mediumLarge: {
        height: spacing(3),
        width: spacing(3),
    },
    large: {
        height: spacing(4),
        width: spacing(4),
    },
    xl: {
        height: spacing(6),
        width: spacing(6),
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        color: palette.secondary.main,
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        color: palette.grey.main,
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
        color: palette.error.main,
    },
}));
const SvgIcon = React.forwardRef((props, ref) => {
    const classes = useStyles();
    const { children, className, color = 'inherit', htmlColor, viewBox = '0 0 24 24', size, ...rest } = props;
    const Svg = 'svg';
    return (React.createElement(Svg, { className: classNames(className, classes.root, {
            // @ts-ignore
            [classes[`color${capitalize(color)}`]]: color !== 'inherit',
            [classes?.[size]]: size,
        }), focusable: "false", viewBox: viewBox, color: htmlColor, ref: ref, ...rest }, children));
});
export default SvgIcon;
//# sourceMappingURL=SvgIcon.js.map